import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMelilla = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1614)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.73914 13.0435H18.2609V14.6087H5.73914V13.0435Z",
				fill: "#818085"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82611 8.34783L12 8.86964L16.1739 8.34783V5.84348L14.5043 6.67828L12 4.17389L9.49566 6.67828L7.82611 5.84348V8.34783Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.78263 16.174H5.21738V13.3044L5.73914 12.5217L5.21738 11.7391V9.91309H6.78263V16.174Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7826 16.174H17.2174V9.91309H18.7826V11.7391L18.2609 12.5349L18.7826 13.3045V16.174Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.21738 11.7391H18.7826V13.3043H5.21738V11.7391Z",
				fill: "#ACABB1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 18.2609C9.69849 18.2609 7.82611 16.3884 7.82611 14.087V8.34787H16.1739V14.087C16.1739 16.3884 14.3015 18.2609 12 18.2609Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.6956C10.5615 16.6956 9.39131 15.5254 9.39131 14.087V9.91312H14.6087V14.087C14.6087 15.5254 13.4385 16.6956 12 16.6956Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82611 8.34784H9.39131V9.91304H7.82611V8.34784Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6087 8.34784H16.1739V9.91304H14.6087V8.34784Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6087 11.7392H16.1739V13.3044H14.6087V11.7392Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82611 11.7392H9.39131V13.3044H7.82611V11.7392Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2174 8.34784H12.7826V9.91304H11.2174V8.34784Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.6957C11.7274 16.6957 11.4645 16.6535 11.2174 16.5756V18.1862C11.4711 18.2346 11.7324 18.2609 12 18.2609C12.2676 18.2609 12.5289 18.2346 12.7826 18.1862V16.5756C12.5355 16.6534 12.2726 16.6957 12 16.6957Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.42619 14.5104L8.17706 15.7596C8.39363 16.2526 8.70263 16.696 9.08241 17.0677L10.1887 15.9615C9.79388 15.5801 9.51886 15.0757 9.42619 14.5104Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.8229 15.7597L14.5738 14.5105C14.4811 15.0757 14.2061 15.5801 13.8114 15.9616L14.9176 17.0679C15.2973 16.6961 15.6064 16.2527 15.8229 15.7597Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1614",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMelilla;
